import { isValidElement, cloneElement, type ReactElement } from 'react'
import clsx from 'clsx'
import useIsVisible from '~/hooks/useIsVisible'

type Animate = string
type Delay = 0 | 100 | 150 | 200 | 300 | 500 | 700 | 1000

interface AnimatedProps {
  animation?: Animate
  delay?: Delay
  children: ReactElement<any>
  className?: string
}

export default function Animated({ animation = 'animate-fade-up', delay = 0, children, className }: AnimatedProps) {
  const [ref, isVisible, isLighthouse] = useIsVisible()

  const animationClass = isLighthouse
    ? ''
    : clsx(
        isVisible && `${animation} animate-ease-in-out animate-duration-500 animate-delay-${delay} motion-reduce:animate-none`,
        isVisible ? 'opacity-100' : 'opacity-0'
      )

  if (!isValidElement(children)) {
    console.warn('[Animated] expects a single valid React element as its child.')
    return null
  }

  return cloneElement(children, {
    // @ts-ignore
    ref,
    className: clsx((children.props as any).className, className, animationClass)
  })
}
